import ResourceManager from "@/pages/admin/components/ResourceManager";
import {
  capacidadOptions,
  categoryLabels,
  categoryOptions,
  estadoOptions,
  servicioOptions,
} from "@/lib/vehicleMeta";
import type { ColumnConfig, FieldConfig } from "@/lib/adminFields";
import type { VehicleCategory } from "@/types";

const fields: FieldConfig[] = [
  { name: "nombre", label: "Nombre de la unidad", type: "text", required: true, full: true, placeholder: "Ej. Camión de mudanza 20 m³" },
  { name: "categoria", label: "Categoría", type: "select", required: true, options: categoryOptions },
  { name: "tipo", label: "Tipo de vehículo", type: "text", placeholder: "Ej. Camión de carga" },
  { name: "capacidad", label: "Capacidad", type: "text", placeholder: "Ej. 20 m³ · 5.500 kg" },
  { name: "capacidad_grupo", label: "Grupo de capacidad", type: "select", options: capacidadOptions },
  { name: "estado", label: "Disponibilidad", type: "select", required: true, options: estadoOptions },
  { name: "servicio", label: "Servicio principal", type: "select", options: servicioOptions.map((value) => ({ value, label: value })) },
  { name: "zona", label: "Zona de operación", type: "text", placeholder: "Ej. Zona metropolitana" },
  { name: "orden", label: "Orden", type: "number", help: "Número menor aparece primero" },
  { name: "activo", label: "Visible en el sitio", type: "switch" },
  { name: "descripcion", label: "Descripción", type: "textarea", full: true },
  { name: "caracteristicas", label: "Características", type: "tags", full: true, help: "Sepáralas con comas" },
  { name: "imagen_url", label: "Fotografía", type: "image", full: true, folder: "flota" },
];

const columns: ColumnConfig[] = [
  { name: "imagen_url", label: "Foto", type: "image" },
  { name: "nombre", label: "Unidad" },
  { name: "categoria", label: "Categoría", type: "muted" },
  { name: "capacidad", label: "Capacidad", type: "muted" },
  { name: "estado", label: "Disponibilidad", type: "muted" },
  { name: "activo", label: "Visibilidad", type: "switch" },
];

const estadoLabels: Record<string, string> = {
  disponible: "Disponible",
  reservado: "Reservado",
  mantenimiento: "En mantenimiento",
  no_disponible: "No disponible",
};

export default function AdminFlota() {
  return (
    <ResourceManager
      table="vehiculos"
      title="Gestión de flota"
      description="Administra las unidades del catálogo: fotografías, capacidad, disponibilidad y visibilidad en el sitio público."
      itemSingular="unidad"
      itemPlural="unidades"
      emptyIcon="ri-truck-line"
      titleField="nombre"
      subtitleField="tipo"
      imageField="imagen_url"
      searchPlaceholder="Buscar por nombre o tipo…"
      fields={fields}
      columns={columns}
      renderCell={(row, column) => {
        if (column.name === "categoria") {
          return (
            <span className="text-sm text-foreground-600">
              {categoryLabels[row.categoria as VehicleCategory] ?? String(row.categoria ?? "—")}
            </span>
          );
        }
        if (column.name === "estado") {
          return (
            <span className="text-sm text-foreground-600">
              {estadoLabels[String(row.estado)] ?? String(row.estado ?? "—")}
            </span>
          );
        }
        if (column.name === "capacidad") {
          return <span className="text-sm text-foreground-500">{row.capacidad ? String(row.capacidad) : "—"}</span>;
        }
        if (column.name === "activo") {
          return null;
        }
        return undefined;
      }}
    />
  );
}